<template>
  <div class="wrapper-orderdetail wh100p">
    <section class="section-navs df-c-sb">
      <div class="back-btn _themecolor f-m df-c-ct" @click="$router.go(-1)">
        <img class="arrow" :src="iconArrowLeft">
        <div>{{$t('order.orderDetail')}}</div>
      </div>
      <div class="code f1 _themecolor df-c-sb f-bold">
        <div class="f1 df-c-ct f-l" v-if="orderData.code">{{orderData.code+(orderData.showNo>1?('-'+orderData.showNo):'')}}</div>
        <div class="f1 df-c-ct f-l" v-else-if="orderData.orderNo">{{$t('order.orderNo')}}：{{orderData.orderNo}}</div>
        <div class="f1 df-c-fe">
          <div class="whitebtn edit-btn" @click="navToMenu" v-if="orderData.status===1&&orderData.orderType!==3">{{$t('order.backMenu')}}</div>
          <div
            class="whitebtn edit-btn" @click="cancelOrderClick"
            v-else-if="orderData.status!==100&&!orderData.combineOrder&&orderData.orderType!==3">
            {{[8,9,10,100].includes(orderData.status)?$t('calc.cancelCalcAndRefund'):$t('calc.cancelCalc')}}
          </div>
        </div>
      </div>
    </section>
    <section class="section-con df-l-fs">

      <div class="section-infos df-c-sb">
        <div class="df-c-fs">
          <div class="f-s">{{$t('order.calcWay')}}：{{calcWayText}}</div>
          <div class="f-xs pad">{{$t('order.payStatus2')}}：{{(orderData.userCost_leftCash)|toprice(2)}}</div>
          <div class="f-xs pad _redcolor">{{$t('order.payStatus1')}}：{{(orderData.leftCash)|toprice(2)}}</div>
          <div class="pad df-c-ct">
            <div class="themebtn-s detail-btn" @click="$refs.Dialog_paymentStatus.open()">{{$t('order.detail')}}</div>
          </div>
        </div>
        <div class="df-c-fs">
          <div class="f-s pad">{{$t('order.orderNo')}}：{{orderData.orderNo|tothousands}}</div>
        </div>
      </div>

      <div class="section-items f1" ref="tablebox">
        <el-table
          :data="cartItems"
          :max-height="tableMaxHeight">
          <!-- :row-class-name="tableRowClassName" -->
          <!-- :max-height="400"
          @selection-change="selectHandler" -->
          <!-- stripe border highlight-current-row -->
          <el-table-column align="left" header-align="center" min-width="140" :label="$t('order.itemName')" prop="itemName" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="df-l-fs ai-fs" style="padding:0 20px;">
                <div>{{scope.row['itemName'+_lang]}}</div>
                <div class="w100p">
                  <CartItemDetail :item="scope.row" :fontSize="14" />
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="60" :label="$t('order.count')" prop="count">
            <template slot-scope="scope">
              <span>{{scope.row.count|tothousands}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="60" label="" prop="">
            <template slot-scope="scope">
              <div v-if="isShowTimeOfPlaceOrders&&hasSendCookIds.includes(scope.row.id)&&scope.row['sendToKitchenTimeText'+_lang]">
                <span class="time f-xxs">{{scope.row['sendToKitchenTimeText'+_lang]}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="60" :label="$t('order.itemPrice')">
            <template slot-scope="scope">
              <span>{{scope.row.itemPrice|toprice(2)}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="60" :label="$t('order.takeoutText')">
            <template slot-scope="scope">
              <span>{{scope.row.takeout?$t('common.yes'):$t('common.no')}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="100" :label="$t('order.remarks')" prop="remarks"></el-table-column>
        </el-table>
      </div>

      <div class="section-total df-sb">
        <div>
          <div class="text f-xxs f-silvery" v-if="selectableTime&&takeOutPickupDateText">{{$t('menu.pickupTime')}}：{{takeOutPickupDateText}}</div>
          <div class="text f-xxs f-silvery">{{$t('menu.remarks')}}：{{orderData|toremark(false)}}</div>
        </div>
        <div class="df-l-fs ai-fe">
          <div class="df-c-ct">
            <div class="text pad f-xxs f-silvery">{{$t('common.price')}}：{{orderData.costOrigin|toprice(2)}}</div>
            <div class="text pad f-xxs f-silvery" v-if="orderData.packageFee">{{$t('common.packageFee')}}：{{orderData.packageFee|toprice(2)}}</div>
            <div class="text pad f-xxs f-silvery" v-if="orderData.serviceFee">{{$t('common.serviceFee')}}：{{orderData.serviceFee|toprice(2)}}</div>
            <div class="text pad f-xxs f-silvery" v-if="orderData.tipsFee">{{$t('common.tip')}}：{{orderData.tipsFee|toprice(2)}}</div>
          </div>
          <div class="df-c-ct">
            <div class="text pad f-xxs f-silvery" v-if="orderData.takeOutDiscountFee">{{$t('common.discounttakeaway')}}：-{{orderData.takeOutDiscountFee|toprice(2)}}</div>
            <div class="text pad f-xxs f-silvery" v-if="orderData.discountFee">{{$t('common.discount')}}：-{{orderData.discountFee|toprice(2)}}</div>
            <div class="text pad f-xxs f-silvery" v-if="sysEnv_x==='us'">{{$t('common.tax')}}({{shopConfig_m.consumptionTax}}%)：{{orderData.consumptionTax|toprice(2)}}</div>
            <div class="text pad f-l f-bold f-silvery">{{$t('common.total')}}：</div>
            <div class="text f-l f-bold _redcolor">{{orderData.userCost|toprice(2)}}</div>
          </div>
        </div>
      </div>

      <div class="section-btns df-c-sa">
        <div class="whitebtn df-l-c-sa" @click="printOrderClick">{{$t('common.printOrder')}}</div>
        <div
          class="df-l-c-sa"
          :class="{'themebtn':cartItems.length,'darkbtn':cartItems.length===0}"
          @click="cartItems.length?calcOrder():''"
          v-if="orderData.status!==100&&orderData.orderType!==3">{{$t('common.pay')}}</div>
        <div class="redbtn df-l-c-sa" @click="refundOrderClick" v-else-if="orderData.status===100&&!orderData.combineOrder">{{$t('common.refund')}}</div>
      </div>

    </section>

    <Dialog
      ref="Dialog_paymentStatus"
      contentWidth="500"
      :dialogTitle="$t('order.detail')"
      :closeable="true">
      <!-- contentWidth="700" -->
      <!-- :closeable="false" -->

      <div class="mydialog" slot="content">
        <div class="text f-l" v-for="(x,i) in orderData.cashPayList" :key="i">{{x['payTypeName'+_lang]}}：{{(x.payCash-x.returnCash)|toprice(2)}}</div>
        <div class="text f-l _redcolor">{{$t('order.payStatus1')}}：{{orderData.leftCash|toprice(2)}}</div>
      </div>

    </Dialog>

    <DialogKey ref="DialogKey" />

    <DialogPayway ref="DialogPayway" @submitDialog="submitDialogPayway" />

    <DialogError ref="DialogError" :messages="stockErrorFoods" />

  </div>
</template>

<script>
import mixin_table_simple from '@/mixins/mixin_table_simple'
import mixin_print from '@/mixins/mixin_print'
import DialogPayway from '@/components/DialogPayway'
export default {
  name: 'orderDetail',
  mixins: [mixin_table_simple, mixin_print],
  components: { DialogPayway },
  data() {
    return {
      orderData: {}, // 订单
      cartItems: [], // 购物车

      otherHeight: 60+40+100+65+108+80,
      
      stockErrorFoods: [], // 余量不足

      hasSendCookIds: [],
      timer_timeHandler: null,

      // #region 取餐时间
      selectableTime: false,
      // #endregion
    }
  },
  computed: {
    calcWayText() {
      switch (this.orderData.userSelectPayType) {
        case 0: return this.$t('order.calcWay0')
        case 1: return this.$t('order.calcWay1')
        case 2: return this.$t('order.calcWay2')
        case 3: return this.$t('order.calcWay3')
        case 4: return this.$t('order.calcWay4')
      }
    },

    takeOutPickupDateText() {
      const TIME = this.orderData.takeOutPickupDate
      if (TIME === '-1') {
        return this.$t('menu.now')
      } else if (TIME) {
        return TIME
      } else {
        return ''
      }
    },
  },
  watch: {
    modelList_x(val) {
      this.pickUpTimeHandler()
    },
  },
  methods: {
    // #region 改变支付渠道
    submitDialogPayway() {
      this.$refs.DialogKey.close()
    },
    // #endregion

    // 打印
    printOrderClick() {
      if (this.printerId_x) {
        this.$api.print_order({
          shopId: this.currentShopId,
          id: this.orderData.id
        }, this.printerId_x).then(res => {
          if (res.status == 0) {
          } else { this._status(res) }
        })
      } else { this.$message.warning(this.$t('print.printerError')) }
    },
    // 付款
    calcOrder() {
      let rD = {
        shopId: this.currentShopId,
        id: this.orderData.id,
      }
      this.$api.order_calc_before(rD).then(res => {
        if (res.status == 0) {
          let _R = res.data
          if (_R.length) {
            // console.log(`%c_R:`, 'color: #f00;', _R)
            this.stockErrorFoods = _R.map(x => {
              if (x.saleOut) {
                return {
                  text_zh: x.item.name_zh + ' 已售罄',
                  text_en: x.item.name_en + ' is sold out',
                }
              } else {
                return {
                  text_zh: x.item.name_zh + ' 可點數量' + x.availableCount + '份',
                  text_en: x.item.name_en + ' remains ' + x.availableCount + (x.availableCount === 1 ? ' order' : ' orders'),
                }
              }
            })
            this.stockErrorFoods.push({
              text_zh: '請修改數量！',
              text_en: 'please change the quantity !',
            })
            this.$refs.DialogError.open()
          } else {
            let { id, isNeedSend, hasSendCookIds } = this.orderData
            isNeedSend
            ? this.autoPrint_here(id, this.cartItems, hasSendCookIds, this.navToClac)
            : this.navToClac()
          }
        } else { this._status(res) }
      })
    },
    navToClac() {
      switch (this.orderData.status) {
        case 4: case 7: case 9:
          this.$router.push(`/calcwayFood?oid=${this.orderId}`)
          break
        case 5: case 8:
          this.$router.push(`/calcwayAvg?oid=${this.orderId}`)
          break
        case 6: case 10:
          this.$router.push(`/calcwayCus?oid=${this.orderId}`)
          break
        default:
          this.$router.push(`/calcway?oid=${this.orderId}`)
          break
      }
    },
    autoPrint_here(orderId, itemsAll, itemIdsSent, callback) {
      this.$confirm(this.$t('print.foodNotSent'), this.$t('common.tips'), {
        confirmButtonText: this.$t('common.yes'),
        cancelButtonText: this.$t('common.no'),
        type: 'warning',
        distinguishCancelAndClose: true,
      }).then(async () => {
        // Mark 现在发送过有未发送不再发送
        callback && callback()
      })
    },


    // #region 退款
    refundOrderClick() {
      const order = this.orderData
      this.$refs.DialogKey.open({
        orderId: this.orderData.id,
        sceneType: 1,
        onConfirm: this.sendAjax_refund,
        showChangePayway: this.isShowWhetherOpenPayment
          && order
          && order.status===100
          && !order.payedWith3rd,
        onChange: () => {
          this.$refs.DialogPayway.open(order)
        }
      })
    },
    async sendAjax_refund() {
      const ORDER = this.orderData

      const _Rs = await this.getData('order', {
        parentOrderId: ORDER.id,
        payed: true,
        returnCash: false,
        eftPay: true,
        subOrder: false,
      })
      if (_Rs && _Rs.length) {
        _Rs.forEach(x1 => {
          const { id: orderId, payType, userCost } = x1
          this.sendAjax_eftRefund({ orderId, payType, userCost }).then(() => {
            this.sendAjax_refund_send(ORDER)
          })
        })
      } else {
        console.log('没有支付订单')
        // 如果现金支付过，弹出钱箱
        if (ORDER.payTypeList && ORDER.payTypeList.includes(5)) {
          this.$tool.dsbridge_call(this.$tool.dsbridge_map.openCashDrawer, '')
        }
        this.sendAjax_refund_send(ORDER)
      }
    },
    sendAjax_refund_send(ORDER) {
      let rD = {
        shopId: this.currentShopId,
        id: ORDER.id,
      }
      this.$api.order_refund(rD).then(res => {
        if (res.status == 0) {
          // ORDER.status = 1
          this.init()
        } else { this._status(res) }
      })
    },
    // #endregion

    // #region eft退款
    sendAjax_eftRefund({ orderId, payType, userCost }) {
      return new Promise(async (resolve, reject) => {
        
        let rD = {
          shopId: this.currentShopId,
          orderId,
          payType,
          userCost,
          ip: this.readerId_x,
        }
        console.log(`%cEFT 请求参数:`, 'color: #00f;', rD)

        const RESULT = this.$tool.dsbridge_call(this.$tool.dsbridge_map.eftRefund, rD)
        console.log(`%cEFT result:`, 'color: #00f;', RESULT)
        if (RESULT === 'error') {
          this.$message.error(this.$t('pay.eftRefundFailed'))
          reject()
        } else {
          resolve()
        }
        
      })
    },
    // #endregion
    
    // 继续点餐
    navToMenu() {
      let type = ''
      switch (this.orderData.orderType) {
        case 1: type = 'normal'; break
        case 2: case 4:
          if (this.orderData.takeoutSettingId) {
            type = 'editcustom&payId=' + this.orderData.takeoutSettingId
          } else {
            type = 'edit' // 這裡因為菜單頁面對takeaway進行置空處理，用edit代替判斷
          }
          break
      }
      this.$router.push(`/menu?oid=${this.orderId}&type=${type}`)
    },
    // 撤销结算
    cancelOrderClick() {
      const { id, status, payTypeList } = this.orderData
      console.log(`%c撤销订单后id+状态:`, 'color: #00f;', id, status)
      if ([8, 9, 10].includes(status)) {
        this.$refs.DialogKey.open({
          orderId: id,
          sceneType: 1,
          onConfirm: () => {
            // 如果现金支付过，弹出钱箱
            if (payTypeList && payTypeList.includes(5)) {
              this.$tool.dsbridge_call(this.$tool.dsbridge_map.openCashDrawer, '')
            }
            this.sendAjax_cancelCalc()
          }
        })
      } else {
        this.sendAjax_cancelCalc()
      }
    },
    async sendAjax_cancelCalc() {

      const _Rs = await this.getData('order', {
        parentOrderId: this.orderData.id,
        payed: true,
        returnCash: false,
        eftPay: true,
        subOrder: false,
      })
      if (_Rs && _Rs.length) {
        await Promise.all(_Rs.forEach(x1 => {
          const { id: orderId, payType, userCost } = x1
          return this.sendAjax_eftRefund({ orderId, payType, userCost })
        })).then(() => {
          this.sendAjax_cancelCalc_send()
        }).catch(() => {
          this.$message.error('EFT多次退款失败！')
        })
      } else {
        this.sendAjax_cancelCalc_send()
      }
    },
    sendAjax_cancelCalc_send() {
      this.$api.payment_cancel({
        shopId: this.currentShopId,
        id: this.orderData.id,
      }).then(res => {
        if (res.status == 0) {
          this.orderData.status = 1
          this.$refs.Dialog_way.close()
        } else { this._status(res) }
      })
    },

    // 判斷购物车是否已经存在
    async judgeCart() {
      const _Rs = await this.getData('order', {
        shopId: this.currentShopId,
        id: this.orderId,
        filterCheckoutOrderItem: true,
      })
      
      if (_Rs.length) {
        let _R = _Rs[0]
        this.orderData = _R
        let userCost_leftCash = Math.round((_R.userCost - _R.leftCash) * 100) / 100
        this.orderData.userCost_leftCash = userCost_leftCash > 0 ? userCost_leftCash : 0
        this.cartItems = _R.orderItemDetailList
        _R.hasSendCookIds = _R.sendPrinterList.map(x => x.orderItemId)
        
        const NUM_NEED = _R.orderItemDetailList.length
        const NUM_SENT = _R.hasSendCookIds.length
        _R.isNeedSend = NUM_SENT > 0 && NUM_NEED !== NUM_SENT // 发送的菜品
        
        console.log(`%c已有的订单:`, 'color: #f00;', _R, _R.status, `已有的购物车:`, this.cartItems)

        if (this.isShowTimeOfPlaceOrders) {
          // #region 发送厨房
          this.hasSendCookIds = []
          this.orderData.sendPrinterList.forEach(x => {
            this.hasSendCookIds.push(x.orderItemId)
          })
          // #endregion

          this.timeHandler(_R)
        }

      } else {
        this.orderData = {}
        this.cartItems = []
      }
      return !!_Rs.length
    },

    // #region 处理发送厨房的时间标志
    timeHandler(data) {
      // console.log(`%c22222`, 'color: #f00;',)
      data.orderItemDetailList.forEach(x1 => {
        // x1.sendToKitchenTime = 1665457788339
        let CURRENT_TIME = new Date().getTime()
        if (x1.payedTime && x1.payedTime < CURRENT_TIME) {
          CURRENT_TIME = x1.payedTime
        }
        if (this.hasSendCookIds.includes(x1.id) && x1.sendToKitchenTime) {
          let t = Math.floor((CURRENT_TIME - x1.sendToKitchenTime) / 1000 / 60)
          if (t > 999) t = '>999'
          if (t < 0) t = '0'
          this.$set(x1, 'sendToKitchenTimeText_zh', t + '分鐘')
          this.$set(x1, 'sendToKitchenTimeText_en', t + ' Min')
        } else {
          this.$set(x1, 'sendToKitchenTimeText_zh', '')
          this.$set(x1, 'sendToKitchenTimeText_en', '')
        }
      })
    },
    // #endregion
    // 获取数据
    async init() {
      this.orderId = this.$route.query.oid

      this.hadCart = await this.judgeCart()
      
      if (this.isShowTimeOfPlaceOrders) {
        clearInterval(this.timer_timeHandler)
        this.timer_timeHandler = setInterval(() => {
          this.orderData && this.orderData.id && this.timeHandler(this.orderData)
        }, 1000)
      }
    },

    pickUpTimeHandler() {
      // console.log(`%cmodelList_x:`, 'color: #00f;', this.modelList_x)
      if (this.modelList_x) {
        const ITEM_MODEL = this.modelList_x.find(x1 => x1.type === 1)
        this.selectableTime = ITEM_MODEL && ITEM_MODEL.enable &&ITEM_MODEL.selectableTime
        // console.log(`%cthis.selectableTime:`, 'color: #00f;', this.selectableTime)
      }
    },
  },
  created() {
    // console.log(`%c123:`, 'color: #00f;', this.company_x)
    // console.log(`%c123:`, 'color: #00f;', this.$route)
    this.pickUpTimeHandler()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init()
    })
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.timer_timeHandler)
    next()
  }
}
</script>

<style lang='scss' scoped>
@import '@/assets/css/util_table.scss';
// .wrapper-orderdetail{padding-left: 20px;box-sizing: border-box;}
.section-navs{
  height: 80px;line-height: 80px;background: #fff;padding: 0 10px;margin-bottom: 20px;
  .back-btn{
    padding: 0 10px;width: auto;height: 80px;white-space: nowrap;font-weight: bold;
    .arrow{width: 24px;height: 24px;margin-right: 12px;}
  }
  .edit-btn{margin-right: 10px;}
  
  .cancel-btn{margin-left:20px;min-width: 130px;}
  .code{margin-left: 40px;}
}
.section-con{
  height: calc(100% - 100px);margin-left: 20px;background: #fff;overflow: hidden scroll;box-sizing: border-box;
  .section-infos{
    height: 65px;line-height: 65px;padding: 0 30px;
    .pad{padding-left: 20px;}
    .detail-btn{min-width: 80px;}
  }
  .section-coupon{
    height: 130px;padding: 34px 20px;box-sizing: border-box;border-bottom: 1px solid #DFDFDF;
    .input{width: 210px;height: 40px;line-height: 40px;border: 1px solid #374978;padding: 0 20px;border-radius: 2px;color: #777;}
    .input::placeholder{color: #777;}
  }
  .section-items{
    height: calc(100% - 273px);
    .item{height: 70px;border-bottom: 1px solid #DFDFDF;}
    .text{margin-left: 16px;color: #777;}
    span.time{text-align: center;background: #000;color: #fff;border-radius: 4px;padding: 2px 8px;}
  }
  .section-total{
    height: 68px;padding: 20px;
    .text{height: 34px;line-height: 34px;}
    .pad{padding-left: 20px;}
  }
  .section-btns{
    height: 80px;width: 70%;margin: 0 auto 20px;
  }
  .section-ways{
    height: 120px;width: 70%;margin: 0 auto 20px;
    .way{width: 140px;height: 120px;}
    .way-icon{width: 80px;height: 80px;}
  }
}
.mydialog{
  min-height: 200px;padding: 80px;
  .text{line-height: 40px;}
}
</style>